import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from "@angular/core";
import { userContextStore } from "../../../../shared/data/user-context.store";
import { resolveNavigationChannel } from "../../../../shared/util/navigation-channel-config";
import { CoreMediaContentRendererComponent } from "../../../coremedia/content/feature/coremedia-content-renderer/coremedia-content-renderer";

@Component({
  selector: "claas-dashboard",
  templateUrl: "./dashboard.html",
  styleUrls: ["./dashboard.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoreMediaContentRendererComponent],
})
export class DashboardComponent {
  private readonly localeStore = inject(userContextStore);

  /** The channel ID of the start channel for the current country/language — same channel used by retrieveMenuTree. */
  protected readonly channelId = computed(() => {
    const channel = resolveNavigationChannel(
      this.localeStore.country(),
      this.localeStore.language(),
    );
    return channel?.channelId ?? null;
  });
}
